export const filterLabelMappings = {
  assignmentType: 'Assignment Type',
  propertyType: 'Property Type',
  status: 'Status'
};
